<template>
    <div class="pip-player">
        <div class="pip-controls">
            <PlayerPlaylist ref="playlistRef"
                            @play="playIndex" />
            <div class="control-row"
                 v-if="playlist.length > 1">
                <button class="player-btn"
                        @click="playPrev">
                    ⏮ 이전
                </button>
                <button class="player-btn"
                        @click="playNext">
                    다음 ⏭
                </button>
            </div>
            <div class="control-row">
                <button class="subtitle-btn"
                        @click="toggleSubtitle">
                    자막
                </button>
                <button class="showPlaylist-btn"
                        @click="togglePlaylist">
                    ☰
                </button>
            </div>
            <SubtitlePanel ref="subtitlePanelRef" />
        </div>
    </div>
</template>

<script setup>
    import { ref, computed } from "vue";
    import { useStore } from "vuex";

    import PlayerPlaylist from "./PlayerPlaylist.vue";
    import SubtitlePanel from "./SubtitlePanel.vue";
    const playlistRef = ref(null);
    const subtitlePanelRef = ref(null);
    const store = useStore();

    const playlist = computed(() => store.state.media.playlist);

    async function playPrev() {
        await store.dispatch("media/playPrev");
    }

    async function playNext() {
        await store.dispatch("media/playNext");
    }

    async function playIndex(index) {
        await store.dispatch("media/playIndex", index);
    }

    function togglePlaylist() {
        playlistRef.value?.toggle();
    }

    function toggleSubtitle() {
        subtitlePanelRef.value?.toggle();
    }
</script>

<style scoped>
    .pip-player {
        width: 100%;
    }

    .pip-controls {
        width: 100%;
    }
</style>